import { createContext } from 'react';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const FileUploadContext = /*#__PURE__*/createContext({
  description: null,
  disabled: false,
  errorText: '',
  fullWidth: false,
  inputId: '',
  inputRef: null,
  onCloseAlert: noop
});

export { FileUploadContext as F };
//# sourceMappingURL=FileUploadContext-CI9_em1Z.js.map
